import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { compareEntities } from '@lycoris-nubila/ngx-lycoris';
import { isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

import { ModuleGraph } from 'module/page/graph/module-graph';
import { ModuleGraphRepositoryPort } from 'module/page/graph/port/module-graph-repository.port';

import { CacheObservable } from '../../../../app-decorators';
import { ModuleGraphState, ModuleGraphStore } from './module-graph.types';

@Injectable()
export class ModuleGraphRepositoryAdapter
	extends QueryEntity<ModuleGraphState>
	implements ModuleGraphRepositoryPort
{
	constructor(protected store: ModuleGraphStore) {
		super(store);
	}

	@CacheObservable()
	public observeModuleGraphsByIds(
		graphsId: string[]
	): Observable<ModuleGraph[]> {
		return this.selectMany(graphsId).pipe(
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			distinctUntilChanged(compareEntities),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	public async saveModuleGraphs(entities: ModuleGraph[]): Promise<void> {
		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}
}
